import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import { MESSAGE_SLICE } from "./sliceNames";
import { MESSAGES_INITIAL_VALUE } from "constants/initialValue";
import { IMessagesState } from "interfaces/redux/reducers";

interface IMessageState {
  id: number;
  text: string;
  subject: string;
  created_at: any;
}

const messageSlice = createSlice({
  name: MESSAGE_SLICE,
  initialState: MESSAGES_INITIAL_VALUE,
  reducers: {
    updateMessages: (state, action: PayloadAction<IMessagesState>): IMessagesState => {
      const { messages = [], is_messages_loading = false } = action.payload;
      return { messages, is_messages_loading };
    },
    updateMessage: (state, action: PayloadAction<IMessageState>): IMessagesState => {
      const message = action.payload;
      return { ...state, message };
    },
    resetMessage: (state): IMessagesState => {
      return {
        ...state,
        message: null,
      };
    },
  },
});

export const { updateMessages, updateMessage, resetMessage } = messageSlice.actions;

export default messageSlice.reducer;
